<script setup lang="ts">
import type { SocialProvider } from '~/composables/useSocialLogin'

const props = defineProps<{
  /** Path to return to after authentication (e.g. the checkout page). */
  redirect?: string
}>()

const { t: $t } = useI18n()
const { pending, start } = useSocialLogin()
const config = useRuntimeConfig()

const ALL_PROVIDERS: { id: SocialProvider, label: string, icon: string, enabled: boolean }[] = [
  { id: 'google', label: 'Google', icon: 'i-simple-icons-google', enabled: config.public.socialGoogleEnabled },
  { id: 'microsoft', label: 'Microsoft', icon: 'i-simple-icons-microsoft', enabled: config.public.socialMicrosoftEnabled },
  { id: 'facebook', label: 'Facebook', icon: 'i-simple-icons-facebook', enabled: config.public.socialFacebookEnabled },
]

const providers = ALL_PROVIDERS.filter(p => p.enabled)
</script>

<template>
  <div class="space-y-3">
    <UButton
      v-for="provider in providers"
      :key="provider.id"
      block
      size="xl"
      color="neutral"
      variant="outline"
      :icon="provider.icon"
      :loading="pending === provider.id"
      :disabled="pending !== null"
      class="justify-center"
      @click="start(provider.id, props.redirect)"
    >
      {{ $t('page.login.continueWith', { provider: provider.label }) }}
    </UButton>
  </div>
</template>
